module.exports = __webpack_public_path__ + "static/linux-fb6f20b1a147dea3c90b508d122f76a2.png";